import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { RootState } from './types';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * App-wide dispatch type. A `ThunkDispatch` so it accepts thunk action creators
 * (e.g. `getTree`, `pollGroupConditions`) as well as plain and RTK Query actions,
 * without the `useDispatch<any>()` escape hatch.
 */
export type AppDispatch = ThunkDispatch<RootState, undefined, AnyAction>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
